import { FC } from "react";
import { SelectImportance } from "./SelectImportance";
import { SettingCard } from "../../../../../components/SettingCard";

type Props = {
  updateCriteriaSettings: (
    criteria: string,
    key: string,
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
  importance?: number | null;
  disabled: boolean;
};

export const CriminalCriteria: FC<Props> = ({
  importance,
  disabled,
  updateCriteriaSettings
}) => {
  return (
    <SettingCard title="Sex offender history">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-content-1000">
          May not be a registered sex offender
        </p>
        <SelectImportance
          importance={importance}
          disabled={disabled}
          onChange={(e) =>
            updateCriteriaSettings("sex_offender_check", "importance", e)
          }
        />
      </div>
    </SettingCard>
  );
};
